import './styles.scss';
import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import GetStarted from 'components/Sections/GetStarted';
import ColumnWrapper from 'Layout/ColumWraper';
import FAQSideText from './FaqSideText';
import { useSelector, useDispatch } from 'react-redux';
import { fetchFAQ, selectFAQ, selectFAQSections, faqIsLoading, selectFAQTags } from 'store/slices/FAQSlice';
import FAQSectionItems from 'components/Sections/FAQ/FAQSection';
import { useEffect, useRef } from 'react';
// import Preloader from 'Layout/Preloader';
import { useAnimation } from 'hooks/useAnimation';
import Helmet from 'react-helmet';
import { generateMetaTags } from 'helpers';

const FAQPage = () => {
    const dispatch = useDispatch();

    const isLoading = useSelector(faqIsLoading);
    const faqData = useSelector(selectFAQ);
    const faqSections = useSelector(selectFAQSections);

    const faqTags = useSelector(selectFAQTags);
    const metaTags = generateMetaTags(faqTags?.tags, 'meta');
    const metaTitle = generateMetaTags(faqTags?.tags, 'title');

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchFAQ());
    }, [dispatch]);

    const container = useRef();
    useAnimation({
        items: ['.faq-page-title h1', '.faq-page-title .body1', '.faq-section-items'],
        container,
        dependencies: [isLoading],
    });
    if (!faqData) {
        return null;
    }

    const sideText = {
        title: faqData.faq.help_title,
        desc: faqData.faq.help_text,
        button_text: faqData.faq.help_link_text,
        button_link: faqData.faq.help_link,
    };

    return (
        <>
            <Helmet title={metaTitle ? `${metaTitle}` : faqData.title} meta={metaTags} />
            <section ref={container} className="inner-container faq-page-title">
                <HeroCrumbs page={'FAQ'} />
                <h1>{faqData.title}</h1>
                <div className="body1">{faqData.description}</div>
            </section>
            <section ref={container}>
                <ColumnWrapper SideText={<FAQSideText data={sideText} />}>
                    <FAQSectionItems sections={faqSections} sideText={sideText} />
                </ColumnWrapper>
            </section>

            <GetStarted cta={faqData.cta} isLoading={isLoading} />
        </>
    );
};

export default FAQPage;
